export const mapStateToProps = (state, ownProps) => {
  const application = ownProps.application
    ? ownProps.application
    : state.borrower.loanApplication;
  return {
    application,
  };
};
